import React from 'react'
import { Icon, Tooltip, Box } from '@allied-solutions/affinity'
import { Info } from '@allied-solutions/affinity-react-icons/dist/standard'

const Hint = props => (
  <Tooltip {...props}>
    <Box display="inline-flex" alignItems="center">
      <Icon size='sm' src={Info} color="darkGray" />
    </Box>
  </Tooltip>
)

export { Hint }
